export const SET_ACTIVE_LINK = "SET_ACTIVE_LINK";
export const SET_ACTIVE_LINK_CANDIDATE = "SET_ACTIVE_LINK_CANDIDATE";
export const SET_BACK_ARROW_VISIBILITY = "SET_BACK_ARROW_VISIBILITY";

export type SidebarActiveLinkAction = {
  type: string;
  activeLink: string;
  activeLinkCandidate: string;
  shouldBackArrowBeShown: boolean;
};

export const setActiveLink = (
  activeLink: string
): Partial<SidebarActiveLinkAction> => {
  return {
    type: SET_ACTIVE_LINK,
    activeLink
  };
};

export const setStoreActiveLinkCandidate = (
  activeLinkCandidate: string
): Partial<SidebarActiveLinkAction> => {
  return {
    type: SET_ACTIVE_LINK_CANDIDATE,
    activeLinkCandidate
  };
};

export const setBackArrowVisibility = (
  shouldBackArrowBeShown: boolean
): Partial<SidebarActiveLinkAction> => {
  return {
    type: SET_BACK_ARROW_VISIBILITY,
    shouldBackArrowBeShown
  };
};
